import {
	MONTHLY_CHECKOUT_START,
	MONTHLY_CHECKOUT_SUCCESS,
	MONTHLY_CHECKOUT_FAILURE,
	MONTHLY_CHECKOUT_RESET,
	MONTHLY_CHECKOUT_RESPONSE_CHANGED,
	MONTHLY_CHECKOUT_RESPONSE_REST_START,
	MONTHLY_CHECKOUT_DETAILS_START,
	MONTHLY_CHECKOUT_DETAILS_SUCCESS,
	MONTHLY_CHECKOUT_DETAILS_FAILURE,
} from './MonthlyCheckout.types';

export const monthlyCheckoutStart = (data: any) => ({
	type: MONTHLY_CHECKOUT_START,
	payload: data,
});

export const monthlyCheckoutSuccess = (data: any) => ({
	type: MONTHLY_CHECKOUT_SUCCESS,
	payload: data,
});

export const monthlyCheckoutFailure = (data: any) => ({
	type: MONTHLY_CHECKOUT_FAILURE,
	payload: data,
});

export const monthlyCheckoutReset = () => ({
	type: MONTHLY_CHECKOUT_RESET,
});

export const monthlyCheckoutResponseChanged = (data: any) => ({
	type: MONTHLY_CHECKOUT_RESPONSE_CHANGED,
	payload: data,
});

export const monthlyCheckoutResponseRestStart = () => ({
	type: MONTHLY_CHECKOUT_RESPONSE_REST_START,
});

export const monthlyCheckoutDetailsStart = (data: any) => ({
	type: MONTHLY_CHECKOUT_DETAILS_START,
	payload: data,
});

export const monthlyCheckoutDetailsSuccess = (data: any) => ({
	type: MONTHLY_CHECKOUT_DETAILS_SUCCESS,
	payload: data,
});

export const monthlyCheckoutDetailsFailure = (data: any) => ({
	type: MONTHLY_CHECKOUT_DETAILS_FAILURE,
	payload: data,
});
